import { lazy } from 'react';
import { IRouteProps } from 'src/modules';

export const route = '/projects/create';

const CreateCollectionsRoute: IRouteProps = {
    path: route,
    exact: true,
    component: lazy(() => import('src/modules/CreateCollections/CreateCollections')),
    name: 'CreateCollections',
};

export default CreateCollectionsRoute;
